import TimeZoneApiUtils from '../utils/api/timeZone';

export const FETCH_TIME_ZONES_SENT = 'FETCH_TIME_ZONES_SENT';
export const FETCH_TIME_ZONES_SUCCEEDED = 'FETCH_TIME_ZONES_SUCCEEDED';
export const FETCH_TIME_ZONES_FAILED = 'FETCH_TIME_ZONES_FAILED';

export function fetchSent() {
  return {
    type: FETCH_TIME_ZONES_SENT,
  };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_TIME_ZONES_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return {
    type: FETCH_TIME_ZONES_FAILED,
  };
}

export function fetch() {
  return (dispatch) => {
    dispatch(fetchSent());
    return TimeZoneApiUtils.fetch().then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}
